var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4070_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45253 9.39134C11.3802 7.43294 11.3536 4.27005 9.39571 2.34292C7.43758 0.415514 4.27549 0.43969 2.34782 2.39809C2.21978 2.52817 2.09787 2.66701 1.98398 2.81211L1.40986 2.24699C1.33608 2.17437 1.22419 2.15379 1.12955 2.19279C1.03358 2.23593 0.972662 2.32833 0.97322 2.43373L0.995736 4.93343C0.996859 5.07542 1.11113 5.1879 1.25423 5.18787L3.75621 5.17414C3.86104 5.17194 3.95357 5.11011 3.99379 5.0121C4.03102 4.91659 4.00922 4.80558 3.93572 4.73323L3.29892 4.10642C3.4031 3.95286 3.52115 3.8113 3.65028 3.68011C4.87142 2.43951 6.87444 2.42339 8.11477 3.64426C9.35483 4.86486 9.37095 6.86899 8.15008 8.10932C6.92921 9.34965 4.92535 9.36439 3.68557 8.14407C3.58489 8.04497 3.42198 8.0457 3.32179 8.14749L2.40204 9.0819C2.30239 9.18314 2.30369 9.34659 2.40437 9.44569C4.36221 11.3728 7.52622 11.3484 9.45253 9.39134Z",
    fill: "#99A8B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4070_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "matrix(-1 0 0 1 11.033 0.03302)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.2a4e135e4202b61fc4905f560a0af4aa.svg";
export { ForwardRef as ReactComponent };